module.exports = __webpack_public_path__ + "static/img/memberType0.e263ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/memberType0.png
// module id = ltX/
// module chunks = 1